(function() {
    var searchTerm = getQueryVariable('query');

    function displaySearchResults(results, store) {
        var searchResults = document.getElementById('search-results');
        var searchResultsAmount = document.getElementById('search-results-amount');

        if (results.length) { // Are there any results?
            var appendString = '';
            var pluralString = '';

            if (results.length > 1){
                pluralString = 's'
            }
            var articlesQty = 'Found ' + results.length + ' game' + pluralString;

            for (var i = 0; i < results.length; i++) {  // Iterate over the results
                var item = store[results[i].ref];
                appendString += '<div class="item">';
                appendString += '<div class="item__thumbnail">';
                appendString += '<a href="' + item.url + '" class="item__thumbnail-link"><img src="' + item.square_image + '" alt="' + item.title + '" title="' + item.title + '" class="item__image" /></a>';
                appendString += '</div>';
                appendString += '<div class="item__info">';
                appendString += '<h2 class="item__name text-shadow"><a class="item__name-link" href="' + item.url + '">' + item.title + '</a></h2>';
                appendString += '<p class="item__description text-shadow">' + item.excerpt + '</p>';
                appendString += '<div class="item__rating rating-stars" title="' + item.rating_value + '">';
                appendString += '<div class="rating-stars__value" style="width: ' + item.rating_percent + '%"></div>';
                appendString += '</div>';
                appendString += '</div>';
                appendString += '</div>';
            }

            searchResults.innerHTML = appendString;
            searchResultsAmount.innerHTML = articlesQty;
        } else {
            searchResults.innerHTML = '<div class="search-results__empty">No results found</div>';
            searchResults.classList.add('search-results__list--empty');
        }
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');

            if (pair[0] === variable) {
                return decodeURIComponent(pair[1].replace(/\+/g, '%20'));
            }
        }
    }


    if (searchTerm) {
        document.getElementById('search-box').setAttribute("value", searchTerm);

        // Initalize lunr with the fields it will be searching on. I've given title
        // a boost of 10 to indicate matches on this field are more important.
        var idx = lunr(function () {
            this.field('id');
            this.field('title', { boost: 10 });
            this.field('description');
        });

        for (var key in window.store) { // Add the data to lunr
            idx.add({
                'id': key,
                'title': window.store[key].title,
                'description': window.store[key].description,
                'body': window.store[key].body
            });

            var results = idx.search(searchTerm); // Get lunr to perform a search
            displaySearchResults(results, window.store); // We'll write this in the next section
        }
    }
})();